import * as React from 'react';
import FeedTabs from './tabs';
import { RailsViewStore } from '../rails_view_store';

interface State {
  html: string;
}

export default class RailsView extends React.Component<null, State> {
  constructor(props) {
    super(props);

    this.state = RailsViewStore.getState();
    this.onSetHTML = this.onSetHTML.bind(this);
  }

  componentDidMount() {
    RailsViewStore.listen(this.onSetHTML);
  }

  componentWillUnmount() {
    RailsViewStore.unlisten(this.onSetHTML);
  }

  componentDidUpdate() {
    if (window.Reverb.Renderer) {
      window.Reverb.Renderer.render(window, this.refs.content);
    }
  }

  onSetHTML() {
    this.setState(RailsViewStore.getState());
  }

  render() {
    return (
      <div className="feed-container">
        <FeedTabs />
        <div className="feed-container__content" ref="content">
          <div className="mt-1"></div>
          <div dangerouslySetInnerHTML={{ __html: this.state.html }} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/discovery/feed/rails_view.tsx